import "./style.css";
import layout from "./layout.html";

export default class Credits {
  static selector = ".credits";

  constructor(block, { author, alignment = "left", title = "Foto di:" } = {}) {
    this.block = block;
    this.block.innerHTML = layout;
    this.titleNode = this.block.querySelector(".credits__title");
    this.authorNode = this.block.querySelector(".credits__author");

    this.author = author;
    this.alignment = alignment;
    this.title = title;
  }

  setup = async () => {
    return new Promise(async (resolve) => {
      this.block.classList.add(`credits--align-${this.alignment}`);
      this.authorNode.innerHTML = this.author;
      this.titleNode.textContent = this.title;

      resolve();
    });
  };

  onReady = async () => {
    return new Promise(async (resolve) => {
      this.mounted = true;

      await this.setup();

      resolve();
    });
  };
}
